export default "__VITE_ASSET__8hgUoIkj__"